import { DateTime } from "luxon";

import { useDesktopBridge } from "../../../features/desktop-bridge/use-desktop-bridge.js";
import { env } from "../../../utils/env.js";
import { BaseModal } from "./base-modal.jsx";
import type { SharedModalProps } from "./base-modal.jsx";

export const InfoModal = (_props: SharedModalProps) => {
  const { desktopAppVersion } = useDesktopBridge();
  const shouldShowDesktopAppVersion = desktopAppVersion !== null;

  return (
    <BaseModal title="Info">
      <div className="flex flex-col gap-2">
        <div>
          <span className="font-semibold">Frontend Version: </span>&nbsp;
          {env.PUBLIC_APPLICATION_VERSION ?? "N/A"}
        </div>

        {shouldShowDesktopAppVersion ? (
          <div>
            <span className="font-semibold">Desktop App Version: </span>&nbsp;
            {desktopAppVersion}
          </div>
        ) : null}

        <div>
          <span className="font-semibold">Build Date: </span>&nbsp;
          {DateTime.fromISO(env.PUBLIC_BUILD_DATE)
            .setLocale("en-GB")
            .toLocaleString({
              dateStyle: "short",
              timeStyle: "short",
            })}
        </div>
      </div>
    </BaseModal>
  );
};
